import { Box } from '@vp/swan';
import React, { useState, useEffect } from 'react';
import useMounted from './src-hooks-useMounted.js';
import PriceLoading from './src-components-PriceLoading.js';

const CSRWrapper = ({ children }) => {
  const isMounted = useMounted();
  const [uniqueID, setUniqueID] = useState(null);
  useEffect(() => {
    setUniqueID(Math.random());
  }, [isMounted]);
  if (!isMounted) return /* @__PURE__ */ React.createElement(PriceLoading, null);
  return /* @__PURE__ */ React.createElement(Box, { key: `price-platform-${uniqueID}` }, children);
};

export { CSRWrapper as default };
//# sourceMappingURL=src-components-CSRWrapper-index.js.map
